import React from 'react';
import GuidesComponent from '../../../components/guides';
const Guides = () => (
  <GuidesComponent/>
)

export default Guides;
